import { toast } from "sonner"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { useDeleteAssignment } from "@/lib/queries"
import type { ManagerAssignmentRow } from "@/lib/types"

// Removes one round for one person. The wording is the reassurance that makes
// the action safe to offer: the round closes as Removed, and the attempts
// behind it stay on the competency record.
export function UnassignDialog({
  assignment,
  onOpenChange,
}: {
  assignment: ManagerAssignmentRow | null
  onOpenChange: (open: boolean) => void
}) {
  const deleteAssignment = useDeleteAssignment()

  const handleDelete = async () => {
    if (!assignment) return
    try {
      await deleteAssignment.mutateAsync(assignment.id)
      toast.success("Round removed")
      onOpenChange(false)
    } catch {
      toast.error("Failed to remove round")
    }
  }

  return (
    <AlertDialog open={assignment !== null} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Remove this round?</AlertDialogTitle>
          <AlertDialogDescription>
            {assignment?.staff_name}'s round of {assignment?.quiz_title} will
            close as Removed. Their attempts stay on record.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDelete}
            disabled={deleteAssignment.isPending}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            Remove
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
